import { render, staticRenderFns } from "./InquiriesTable.vue?vue&type=template&id=1b74bd40"
import script from "./InquiriesTable.vue?vue&type=script&lang=js"
export * from "./InquiriesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports